import { Component, Optional, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WarningPopupComponent {
  constructor(
    @Optional() private readonly dialogRef: DynamicDialogRef | null
  ) { }

  close(response: boolean): void {
    this.dialogRef?.close(response);
  }
}
